import React, { useEffect, useRef } from "react";
import Phaser from "phaser";
import MenuScene from "./scenes/MenuScene";
import HighScoreScene from "./scenes/HighScoreScene";
import DocsScene from "./scenes/DocsScene";
import DailyChallengeScene from "./scenes/DailyChallengeScene";
import EpochEndScene from "./scenes/EpochEndScene";
import XAuth from "./game/XAuth";
import WalletManager from "./game/WalletManager";
import "./App.css";
import StageScene from "./scenes/StageScene";



function App() {
  const phaserRef = useRef(null);
  const gameRef = useRef(null);

  useEffect(() => {
    let cancelled = false;

    async function init() {
      // Handle X OAuth callback FIRST — must complete before game starts
      // so MenuScene can see the signed-in user
      await XAuth.handleCallback().catch(() => {});

      // Silently reconnect Phantom wallet if previously approved
      await WalletManager.reconnect().catch(() => {});

      // Wait for "Press Start 2P" font to load before creating Phaser game.
      // Without this, first-visit renders text with fallback font metrics,
      // causing broken layout. Timeout after 3s to avoid infinite hang.
      try {
        await Promise.race([
          document.fonts.load('16px "Press Start 2P"'),
          new Promise((resolve) => setTimeout(resolve, 3000)),
        ]);
      } catch {
        // Font loading API not supported — proceed anyway
      }

      if (cancelled || gameRef.current) return;

      const isMob = window.innerWidth < 600;
      const gameW = isMob ? 400 : 800;
      const gameH = isMob
        ? Math.round(400 * (window.innerHeight / window.innerWidth))
        : 600;

      const config = {
        type: Phaser.CANVAS,
        width: gameW,
        height: gameH,
        parent: phaserRef.current,
        backgroundColor: "#0a0a0a",
        pixelArt: true,
        scale: {
          mode: Phaser.Scale.FIT,
          autoCenter: Phaser.Scale.CENTER_BOTH,
        },
        scene: [
          MenuScene,
          HighScoreScene,
          DocsScene,
          DailyChallengeScene,
          EpochEndScene,
          StageScene,
        ],
      };

      gameRef.current = new Phaser.Game(config);
      // E2E/visual tests only: builds made with REACT_APP_E2E=true expose the game
      if (process.env.REACT_APP_E2E === "true") window.__woodchuck = gameRef.current;
    }

    init();

    return () => {
      cancelled = true;
      if (gameRef.current) {
        gameRef.current.destroy(true);
        gameRef.current = null;
      }
    };
  }, []);

  return (
    <div className="App">
      <div ref={phaserRef} id="game-container" />
    </div>
  );
}

export default App;
